import React from 'react';

import { Typography } from '@mui/material';
import { useGetGradeWithLabelBasedOnThematic } from 'modules/GradeBook/hooks/useGetGradeWithLabelBasedOnThematic';

import { IStudentGradeModel } from '@common/models/StudentGrades/StudentGrade';

import * as Styled from './styled';

interface PropsType {
	grade: IStudentGradeModel;
}

function GridGradeScore({ grade }: PropsType) {
	const label = useGetGradeWithLabelBasedOnThematic(grade);

	return (
		<Styled.Wrap isThematic={grade.isThematic}>
			<Typography variant="subtitle2">{label}</Typography>
		</Styled.Wrap>
	);
}

export default GridGradeScore;
